import {OrderService} from "./order.service";
import {Component} from "@angular/core";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {ActivatedRoute, Router, Params} from "@angular/router";
import {ConfirmDialogService} from "../confirm-dialog/confirm-dialog-service";
import {OrderGqlModel} from "./order.gql-model";
import {handleErrors} from "../misc/handle-errors.decorator";
import {BreadcrumbGqlModel} from "../breadcrumbs/breadcrumb.gql-model";

@Component({
  templateUrl: "./order-show.template.pug",
  providers: [
    OrderService,
    ConfirmDialogService,
  ],
})
export class OrderComponent extends RouteHelper {
  error: Error;
  id: string;
  order: OrderGqlModel = new OrderGqlModel({});
  breadcrumbs: BreadcrumbGqlModel[] = [];

  paramsMap: RouteMapping[] = [
    {fieldName: "id", paramName: "id"} as RouteMapping,
  ];

  @handleErrors()
  async loadData() {
    const {order, breadcrumbs} = await this.orderService.getOrderById(this.id, true);
    this.order = order;
    this.breadcrumbs = breadcrumbs;
  }

  navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["order"], {queryParams, skipLocationChange});
  }

  @handleErrors()
  async remove() {
    const warning = this.order.plannedItems > 0 ?
      ` ${this.order.plannedItems} item(s) will be removed from this order.` :
      "";

    const result = await this.confirmDialogService.confirm(
      "Confirm",
      `Are you sure you want to delete this order?${warning}`,
    );

    if (result) {
      await this.orderService.remove(this.order.id);
      await this.router.navigate(["/orders"], {queryParams: {siteId: this.order.siteId}});
    }
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private orderService: OrderService,
    private confirmDialogService: ConfirmDialogService,
  ) {
    super();
  }
}
